"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtworkGrid = exports.FullArtworkGrid = void 0;

require("core-js/modules/es6.object.assign");

var _ = require("./");

var _react = _interopRequireDefault(require("react"));

var _Responsive = require("../../Utils/Responsive");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FullArtworkGrid = function FullArtworkGrid(props) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Responsive.Media, {
    at: "xs"
  }, _react.default.createElement(_.ArtworkGridExample, _extends({
    columnCount: 2
  }, props))), _react.default.createElement(_Responsive.Media, {
    at: "sm"
  }, _react.default.createElement(_.ArtworkGridExample, _extends({
    columnCount: 3
  }, props))), _react.default.createElement(_Responsive.Media, {
    greaterThanOrEqual: "md"
  }, _react.default.createElement(_.ArtworkGridExample, _extends({
    columnCount: 4
  }, props))));
};

exports.FullArtworkGrid = FullArtworkGrid;
var ArtworkGrid = _.ArtworkGridExample;
exports.ArtworkGrid = ArtworkGrid;
//# sourceMappingURL=ArtworkGrid.js.map